// src/components/MainContent.jsx
import React from 'react';
import facultyLogo from '../../assets/mora-logo.png'; // Correct path to the faculty logo


const MainContent = () => {
  return (
    <div className="main-content">
      <div className="welcome-message">
        <img src={facultyLogo} alt="Faculty Logo" className="faculty-logo" />
        <h2>Welcome to Faculty of<br />
          Information Technology
        </h2>
        <br />
        <h3>Server Room Monitoring System</h3>
      </div>
    </div>
  );
};

export default MainContent;